import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'

import Main from './containers/main'
import MakeClaimmbFinanceCheck from './containers/makeClaimMbFinanceCheck'
import SignDocuments from './containers/signDocuments'
import SignHearingLoss from './containers/signHearingLoss'
import { PARTNER_PATHS } from './helpers/leadAttribution'

export default function AppRouter() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route path="/" element={<MakeClaimmbFinanceCheck />} />
                    <Route path="/sign/:token" element={<SignDocuments />} />
                    <Route path="/hearing-loss/sign/:token" element={<SignHearingLoss />} />
                    {/* Partner landing links: tagged on first load, then sent to the claim form */}
                    {Object.keys(PARTNER_PATHS).map((path) => (
                        <Route key={path} path={path} element={<Navigate to="/" replace />} />
                    ))}
                </Route>
            </Routes>
        </Router>
    )
}
